import dayjs, { Dayjs } from 'dayjs';
import { FC, useCallback, useMemo } from 'react';
import { sortBy } from 'lodash';
import { Talhao } from '../../../../@types';
import { LinhaTempo } from '../../../../@types/linha-tempo';
import LinhaTempoItem from './linha-tempo-item';

const Row: FC<PropTypes> = ({ dates, talhao, itens, index }) => {
  // unusedItens é alterado por referencia
  const pickRowData = useCallback(
    (unusedItens: LinhaTempo[]) => {
      let dateIndex = 0;
      const row: RowItem[] = [];

      while (dates.length > dateIndex) {
        const date = dates[dateIndex];
        const itemIndex = unusedItens.findIndex((item) =>
          date.isSame(item.dataInicio, 'day'),
        );

        let item: LinhaTempo | undefined;

        if (itemIndex >= 0) {
          item = unusedItens[itemIndex];
          unusedItens.splice(itemIndex, 1);
        }

        let size;
        if (item) {
          size = dayjs(item.dataTermino).diff(item.dataInicio, 'day') + 1;
        } else {
          size = 1;
        }

        dateIndex += size;
        row.push({ item, size, key: date.unix() });
      }

      return row;
    },
    [dates],
  );

  const itensRows = useMemo(() => {
    const unusedItens = sortBy(itens, 'dataInicio');

    const rows: RowItem[][] = [];

    while (unusedItens.length > 0) {
      rows.push(pickRowData(unusedItens));
    }

    return rows;
  }, [pickRowData, itens]);

  const trClassName = index % 2 ? 'surface-50' : 'bg-white';

  return (
    <>
      <tr className={trClassName}>
        <td rowSpan={itensRows.length + 1} className="vertical-align-top p-2">
          {talhao.descricao}
        </td>
      </tr>

      {itensRows.map((row, itemRowIndex) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr key={itemRowIndex} className={trClassName}>
          {row.map(({ item, size, key }) => (
            <td key={key} colSpan={size}>
              {item && <LinhaTempoItem dates={dates} item={item} />}
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

type RowItem = {
  item: LinhaTempo | undefined;
  size: number;
  key: number;
};

type PropTypes = {
  talhao: Talhao;
  itens: LinhaTempo[];
  dates: Dayjs[];
  index: number;
};

export default Row;
